import { fireLinkTag } from './tagManager';

export function tagHexa360() { // eslint-disable-line import/prefer-default-export
  const tagName = 'Hexa_360';
  const data = {
    event_name: tagName,
    link_name: tagName,
  };
  fireLinkTag(data);
}
